<template>
  <div id="tf-bodorplus" class="text-center">
    <div class="container">
      <div class="section-title center">
        <h2>{{ $t("home.look") }} <strong>Bodor+</strong></h2>
        <div class="line">
          <hr />
        </div>
        <div class="clearfix"></div>
        <small
          ><em>{{ $t("home.bpin") }}</em></small
        >
      </div>
      <div class="space"></div>
      <div class="flexBox">
        <div class="item service">
          <i class="fa fa-desktop"></i>
          <h4>
            <strong>{{ $t("home.web") }}</strong>
          </h4>
          <p>
            {{ $t("home.webin") }}
          </p>
        </div>

        <div class="item service">
          <i class="fa fa-mobile"></i>
          <h4>
            <strong>{{ $t("home.app") }}</strong>
          </h4>
          <p>
            {{ $t("home.appin") }}
          </p>
        </div>

        <div class="item service">
          <i class="fa fa-camera"></i>
          <h4>
            <strong>{{ $t("home.monitor") }}</strong>
          </h4>
          <p>
            {{ $t("home.monitorin") }}
          </p>
        </div>

        <div class="item service">
          <i class="fa fa-bullhorn"></i>
          <h4>
            <strong>{{ $t("home.dc") }}</strong>
          </h4>
          <p>
            {{ $t("home.dcin") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style scoped>
.flexBox {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.item {
  width: 23%;
}
@media (max-width: 991px) {
  .item {
    width: 48%;
    margin-bottom: 15px;
  }
}
@media (max-width: 767px) {
  .item {
    width: 85%;
    margin: 0px auto 15px auto;
  }
}
</style>
